import { stringify } from "qs";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { FacilityFilterConditionData } from "../../../models/FacilityFilterConditionData";
import { LocationData } from "../../../models/LocationData";
import LocalStorageSvc from "../../../services/localStorageSvc";
import { convertFormDataToQueryParams } from "../../../utils/conditionFormDataHelpers";
import ListTopBar from "../ListTopBar";
import RefactoredFacilityTable from "../RefactoredFacilityTable";

import "./styles.scss";

export interface IFacilityListProps {
  dataList: LocationData[];
  totalCount: number;
  conditionFormData: FacilityFilterConditionData;
  filterFormData: any;
  organizationId: string;
  onClickFilter: () => void;
  onClickClearFilterCondition: () => void;
  onChangeFilterFormData: (filterFormData: any) => void;
}

export const FacilityList: React.FunctionComponent<IFacilityListProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityListPage.facilityList.${key}`);

  const {
    dataList,
    totalCount,
    conditionFormData,
    filterFormData,
    organizationId,
    onClickFilter,
    onClickClearFilterCondition,
    onChangeFilterFormData,
  } = props;

  const history = useHistory();

  return (
    <>
      <div className="white-border-panel">
        <ListTopBar
          conditionFormData={conditionFormData}
          filterFormData={filterFormData}
          onClickFilter={() => {
            onClickFilter();
          }}
          onClickClearFilterCondition={() => {
            onClickClearFilterCondition();
          }}
          onChangeFilterFormData={(filterFormData: any) => {
            onChangeFilterFormData(filterFormData);
          }}
        />

        <RefactoredFacilityTable
          dataList={dataList}
          totalCount={totalCount}
          filterFormData={filterFormData}
          conditionFormData={conditionFormData}
          organizationId={organizationId}
          onChangeFilterFormData={(nextFilterFormData) => {
            onChangeFilterFormData(nextFilterFormData);
          }}
          onApplyFilterCondition={(nextConditionFormData, textFilters) => {
            const queryParams: Record<string, any> =
              convertFormDataToQueryParams(nextConditionFormData);

            const prefectureKeyword = textFilters?.prefecture?.trim() || "";
            const cityKeyword = textFilters?.city?.trim() || "";

            if (prefectureKeyword || cityKeyword) {
              delete queryParams.municipality_id;
            }

            if (prefectureKeyword) {
              queryParams.prefecture = prefectureKeyword;
            } else {
              delete queryParams.prefecture;
            }

            if (cityKeyword) {
              queryParams.city = cityKeyword;
            } else {
              delete queryParams.city;
            }

            LocalStorageSvc.setItem("FacilityListPage_Config", {
              filterFormData,
              searchQuery: queryParams,
            });
            history.replace({
              search: stringify(queryParams, { arrayFormat: "repeat" }),
            });
          }}
        />
      </div>
      <small className="footnote">
        {t("may_require_gbp_login")} <br />
        {_t("data.data_possibly_outdated")}
      </small>
    </>
  );
};

export default FacilityList;
